










import { CategoryItem } from '@/interfaces/category-item';
import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import Left from '../layout/left.vue';
const System = namespace('System');
@Component({
  components: { Left }
})
export default class Platform extends mixins(MenuMixin) {
  @State MENU_INDENT: any;
  
  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;

  menu: CategoryItem[] = [{ title: '平台管理', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] }];

  created() {
    this.initMenu();
  }

  initMenu() {
    if (this.ROLE_MENU.length === 0) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    } else {
      this.MENU('PERMISSION') && this.menu[0].children.push({ title: '系统授权管理', key: '/platform/permision', oprate: false, icon: 'fa-vcard' });
      this.MENU('OPS_LOG') && this.menu[0].children.push({ title: '操作日志管理', key: '/platform/syslog', oprate: false, icon: 'fa-list-alt' });
    }
  }

  update(key: string) {
    if (/\/platform/.test(key)) {
      let index = this.activeTabs.findIndex((v: any) => v.path.startsWith(key));
      if (index > -1) {
        this.setActiveTabs(this.activeTabs[index]);
        this.$router.push(this.activeTabs[index].fullPath);
      } else {
        this.$router.push(key);
      }
    }
  }
}
